import React, { useEffect } from 'react';
import { Page } from '@components/page';
import { Col } from 'antd';
import { useDispatch } from 'react-redux';
import { LeftOutlined } from '@ant-design/icons';
import { Header } from './components/header';
import { Body } from './components/body';
import { fetchApprovalMarketing } from '@redux/slices/approval-marketing';
import { fetchAvailableTypes } from '@redux/slices/order';
import { fetchDivisions } from '@redux/slices/divisions';
import { fetchUsers } from '@redux/slices/users';
import { CardTable } from '@components/table/styled';
import { translate } from '@components/i18n';

export const ApprovalMarketing: React.FC = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchApprovalMarketing());
        dispatch(fetchAvailableTypes());
        dispatch(fetchDivisions());
        dispatch(fetchUsers());
    }, []);

    return (
        <Page
            title={translate('pages.marketingApprovals')}
            greyBackground
            onClickGoBack
            menuIcon={<LeftOutlined />}
        >
            <Col span={22} style={{ alignSelf: 'center' }}>
                <h2 style={{ marginTop: '15px' }}>
                    {translate('titlePages.marketingApprovals')}
                </h2>
                <CardTable>
                    <Header />
                    <Body />
                </CardTable>
            </Col>
        </Page>
    );
};
